import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import closeBtn from '../../assets/popup_close.svg';
import AddAchivements from './popups/AddAchivements';
import AddLink from './popups/AddLink';
import AddSocialMedia from './popups/addSocialMedia';
import EditName from './popups/EditName';

import '../../styles/main.scss';
import '../../styles/components/options/editPopup.animation.scss';

function EditModal({ editmodal }) {
	const handleEditState = (data?: any) => {
		document.querySelector('.popup_wrapper')?.classList.add('scale-out-center'); //animation
		setTimeout(() => {
			modal.handleEditState?.(data);
			setactive(false);
		}, 100);
	};

	const [modal, setmodal] = useState({
		type: 'text',
		title: '',
		name: '',
		handleEditState: (data: any) => {},
	});

	const [active, setactive] = useState(false);

	useEffect(() => {
		showModal();
	}, [editmodal]);

	const showModal = () => {
		setmodal(editmodal);
		if (modal.name != '') setactive(true);
	};

	if (!active) {
		return <></>;
	}

	return (
		<div className='modal_container' style={{ display: 'flex' }}>
			<div className='popup_wrapper scale-up-center'>
				<div className='popup_title_wrapper'>
					<div className='popup_title'>Edit {modal.title}</div>
					<div className='close_popup'>
						<img
							src={closeBtn}
							alt=''
							onClick={() => {
								handleEditState();
							}}
						/>
					</div>
				</div>
				{(modal.name === 'name' ||
					modal.name === 'userName' ||
					modal.name === 'occupation' ||
					modal.name === 'videoRef') && (
					<EditName
						type={modal.type}
						name={modal.name}
						onHanleSuccess={data => {
							handleEditState(data);
						}}
					/>
				)}
				{modal.name == 'bio' && (
					<EditName
						type={'textarea'}
						name={modal.name}
						onHanleSuccess={data => {
							handleEditState(data);
						}}
					/>
				)}
				{modal.name === 'socialMedia' && (
					<AddSocialMedia
						onSave={data => {
							handleEditState(data);
						}}
					/>
				)}
				{modal.name === 'awards' && (
					<AddAchivements
						onHanleSuccess={data => {
							handleEditState(data);
						}}
					/>
				)}
				{modal.name == 'links' && (
					<AddLink
						type={modal.type}
						name={'add_link'}
						onHanleSuccess={data => {
							handleEditState(data);
						}}
					/>
				)}
			</div>
		</div>
	);
}

const mapStateToProps = ({ common }) => ({
	editmodal: common?.editmodal,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(EditModal);
